// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__3PHs1","light":"logo_light__BJFNi","color":"logo_color__2MDl7","small":"logo_small__2VEup","medium":"logo_medium__3Yzb2"};